<div class="container vh-100 d-flex flex-column justify-content-center align-items-center text-center">

  <h1 class="block-404 mb-3">404</h1>
  <b class="fs-4">{{'NotFound.Page' | translate}}</b>
  <p class="mb-4  fw-semibold">{{'NotFound.P' | translate}}</p>
  <button class="btn btn-primary mt-3" (click)="goBack()">{{'NotFound.Btn' | translate}}</button>

</div>  